export default {"src":"/_next/static/media/persimmon.f8022adc.svg","height":681,"width":681,"blurWidth":0,"blurHeight":0};